<template>
  <div class="care">
    <designer_item
      v-for="(item, index) in designer_list"
      :key="index"
      :index="index"
      :mini_flag="true"
      :designer_obj="item"
      @getFrontDesigners="getFrontCollections"
    ></designer_item>
    <div class="page_box">
      <my_page :layerpageinfo="layerpageinfo" @pageChange="changePage"></my_page>
    </div>
  </div>
</template>

<script>
import designer_item from "@/components/list_item/designer_list_item.vue";
import my_page from "@/components/myPage/myPage.vue";

export default {
  components: {
    designer_item,
    my_page
  },
  data() {
    return {
      designer_list: [],
      temp_list: [],
      layerpageinfo: {
        pageSize: 3,
        pageNo: 0,
        total: 0
      }
    };
  },
  created() {
    this.getFrontCollections();
  },
  methods: {
    // 页数切换
    changePage(pageNo) {
      this.layerpageinfo.pageNo = pageNo;
      this.getFrontCollections();
    },
    // 查询收藏的列表
    getFrontCollections() {
      this.temp_list = [];
      let obj = {
        type: "CollectionTypeFollow",
        entity_type: "EntityTypeDesigner",
        ...this.layerpageinfo
      };
      this.api.getFrontCollections(obj).then(res => {
        console.log(res);
        if (res.error.err_code !== 0) return;
        let list = res.obj.list;
        this.layerpageinfo.total = res.obj.totalSize;
        // 根据收藏记录中的作品code查询作品信息
        if (!list.length) {
          this.designer_list = [];
          return;
        }
        list.forEach(item => {
          this.getFrontDesigners(item.code);
        });
      });
    },
    // 条件查询设计师列表
    getFrontDesigners(code) {
      this.api.getFrontDesigners({ code: code }).then(res => {
        console.log(res);
        if (res.error.err_code !== 0) return;
        let list = res.obj.list;
        this.temp_list.push(list[0]);
        this.designer_list = [...this.temp_list];
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>